import React from 'react';
import type { Key } from '@heroui/react';
import { fromBranchPickerKey, toBranchPickerKey } from './branchScopeMeta';

/**
 * The branch picker's Select keys for a branch held as an id (rulebook §5.3,
 * bos-app#138). All branches has a key of its own, and the key the Select
 * emits narrows back to a branch, or `null` for All branches. Every screen
 * holds its branch as an id, so the conversion is made here once, for the
 * shared branch field.
 */
export const useBranchScopePicker = (
    value: string | null,
    onChange: (branchId: string | null) => void,
) => {
    const onSelectionChange = React.useCallback(
        (key: Key | null) => onChange(fromBranchPickerKey(key)),
        [onChange],
    );
    return { selectedKey: toBranchPickerKey(value), onSelectionChange };
};
